///<reference path="../../employee/sections/employee.licensesInsurance.section.ts"/>
module Meevo.Plugins.Student {
    "use strict";
    /**
    * licensesInsurance Section of Employee 
    */
    export class LicensesInsuranceSection extends Meevo.Plugins.Employee.LicensesInsuranceSection {
        public get auditNounForSave() {
            return Model.NounEnum.StudentLicenseInsurances;
        }
    }
}